import React, { createContext, useContext } from 'react';
import { useGet } from '@hooks';

const API_DOMAIN = process.env.REACT_APP_API_DOMAIN || '';

interface VersionResponse {
  version: string;
}

const VersionContext = createContext<string | null>(null);

/**
 * Fetches the SMP backend application version from `GET {api}/version` exactly
 * once and shares it app-wide, so components (e.g. the AppBar) can display it
 * without each triggering their own request.
 */
export const VersionProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { data } = useGet<VersionResponse>(
    `${API_DOMAIN}version`,
    {},
    true,
    true
  );
  return (
    <VersionContext.Provider value={data?.version ?? null}>
      {children}
    </VersionContext.Provider>
  );
};

/** The backend/API version string, or null while loading or on failure. */
export const useApiVersion = (): string | null => useContext(VersionContext);
